import { Address } from "./Address";
import { Product } from "./Product";

export interface Client {
  ativo: boolean;
  tipo: ClientTypeEnum;
  metodo_pagamento: string;
  tipo_recorrencia: string;
  enderecos: Address[];
  favoritos: Product[];
  _id: string;
  nome: string;
  cnpj: string;
  razao_social: string;
  tipo_empresa: string;
  media_faturamento: number;
  telefone: string;
  usuario: string;
  notificacoes: ClientNotification[];
  createdAt: string;
  updatedAt: string;
  endereco_principal: Address;
  data_nascimento: Date;
}

export enum ClientTypeEnum {
  B2B = "B2B",
  B2C = "B2C",
}

export interface ClientNotification {
  _id: string;
  titulo: string;
  texto: string;
  id_pedido: string;
  createdAt: Date;
}
